import { ErrorBoundary } from "@vyne-shared/components/ErrorBoundary";
import { Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

export const RootComponent = () => (
    <ErrorBoundary>
        <Outlet />
        <TanStackRouterDevtools />
    </ErrorBoundary>
);
